export const orderStatus = {
    1: <div className="order-button order-pending">Pending</div>,
    2: <div className="order-button order-placed">Order Placed</div>,
    3: <div className="order-button order-confirmed">Confirmed</div>,
    4: <div className="order-button order-preparing">Preparing</div>,
    5: <div className="order-button order-ready">Ready</div>,
    6: <div className="order-button order-delivered">Delivered</div>,
    7: <div className="order-button order-cancel-request">Cancel Requested</div>,
    8: <div className="order-button order-cancelled">Cancelled</div>,
    9: <div className="order-button order-rejected">Rejected</div>,
}